<template>
  <div class="container" :class="'step' + step">
    <p class="info" v-if="!isMobile">
       Global Brands, Local Retailers, One Entrepreneur Dream!
    </p>
    <p class="info-sub" v-if="!isMobile">
      Shop smarter. | Flexible payments. | No MOQ & Free shipping.
    </p>

    <!--登陆-->
    <div class="login" v-if="loginType == 'login'" v-loading="googleLogin">
      <img src="https://master-shopvidi.s3.amazonaws.com/index_images/shop_logo%402x.png" class="logo login-logo" />
      <el-form :model="loginForm" ref="loginForm" >
        <el-form-item
          prop="email"
          :rules="[
            {
              required: true,
              message: 'Please enter the email',
              trigger: 'blur',
            },
            // {
            //   type: 'email',
            //   message: 'Please enter the correct email address',
            //   trigger: ['blur', 'change'],
            // },
            { validator: checkEmail, trigger: [] }
          ]"
        >
          <el-input auto-complete="new-password" oninput="if(value){value=value.toLowerCase()}" onblur="if(value){value=value.trim()}" class="cust-input" v-model="loginForm.email" placeholder="Email"></el-input>
        </el-form-item>
        <el-form-item
          prop="password"
          :rules="{
            required: true,
            message: 'Please enter the password',
            trigger: 'blur',
          }"
        >
          <el-input
            auto-complete="new-password"
            v-model="loginForm.password"
            :type="passw"
            class="cust-input"
            placeholder="Password"
          >
            <i slot="suffix" @click="showPass">
              <img
                v-if="passw=='password'"
                style="width:16px;height:16px"
                src="../../assets/img/icon-hide.png"
                alt="" />
              <img
                v-else
                style="width:16px;height:16px"
                src="../../assets/img/icon-show.png"
                alt="" />
            </i>
          </el-input>
        </el-form-item>
        <el-form-item >

<!--          <el-checkbox class="cust-checkbox" v-model="loginForm.remember">Remember</el-checkbox>-->

          <div class="forget-btn" @click="$router.push('/forget')">
            Forgot password?
          </div>
        </el-form-item>
        <el-form-item class="login-btn"
          ><el-button
            :loading="loginLoading"
            type="primary"
            @click="submitForm('loginForm')"
            class="btn"
            >Login</el-button
          ></el-form-item
        >
        <el-form-item
          ><el-button @click="signUp" class="btn1 cust-button"
            >Register</el-button
          ></el-form-item
        >
        <el-form-item>
          <GoogleLogin @googleCallBack="googleCallBack"/>
        </el-form-item>
      </el-form>
    </div>
    <!--注册-->
    <div class="register" v-if="loginType == 'register'" v-loading="reging">
      <div v-if="step == 0">
        <img src="https://master-shopvidi.s3.amazonaws.com/index_images/shop_logo%402x.png" class="logo reg-logo" />
        <el-form :model="registerForm" ref="registerForm" class="demo-ruleForm" :rules="rules">
          <el-form-item
            class="flex cust-form-item"
            prop="username"
            :rules="{
              required: true,
              validator: userNameCheck,
              trigger: 'blur',
            }"
          >
            <el-input
              v-model="registerForm.firstName"
              class="cust-input"
              placeholder="First Name"
              oninput="if(value){value=value.toLowerCase()}"
              onblur="if(value){value=value.trim()}"
            ></el-input>

          </el-form-item>
          <el-form-item
            class="flex cust-form-item"
            prop="username"
            :rules="{
              required: true,
              validator: userNameCheck2,
              trigger: 'blur',
            }"
          >

            <el-input
              v-model="registerForm.lastName"
              placeholder="Last Name"
              class="cust-input"
              oninput="if(value){value=value.toLowerCase()}"
              onblur="if(value){value=value.trim()}"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="email"
            class="cust-form-item"
            :rules="[
            {
              required: true,
              message: 'Please enter the email',
              trigger: 'blur'
            },
            // {
            //   type: 'email',
            //   message: 'Please enter the correct email address2',
            //   trigger: ['change']
            // },
            { validator: checkEmail, trigger: 'blur' }
          ]"
          >
            <el-input
              v-model="registerForm.email"
              placeholder="Business Email"
              oninput="if(value){value=value.toLowerCase()}"
              onblur="if(value){value=value.trim()}"
              class="cust-input"
            ></el-input>
          </el-form-item>
          <el-form-item class="flex" v-if="false">
            <el-input
              v-model="registerForm.code"
              placeholder="Verification Email Code"
            ></el-input>

            <el-button class="btn2" @click="getCode">{{ timeValue }}</el-button>
          </el-form-item>
          <el-form-item
            class="flex cust-form-item cust-form-item2"
            prop="phone"
          >
            <el-select
              v-model="codeObject"
              filterable
              placeholder="+ Country Code"
              @change="codeChange"
              class="cust-input_clear_border"
            >
            <template slot="empty" >
                <p style="display:none">no data</p>
            </template>
              <el-option
                v-for="(item, index) in options"
                :label="item.text"
                :value="item"
                :key="index"
              >
                <span style="float: left">{{ item.text }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{
                  item.value
                }}</span>
              </el-option>
            </el-select>
            <el-divider direction="vertical" class="cust-divider"></el-divider>

            <el-input
              v-model="registerForm.phone"
              placeholder="Phone"
              style="width: 140%;"
              class="cust-input_clear_border"
              @input="changePhone"

            ></el-input>
<!--            <img
              src="../../assets/img/wapp.png"
              class="wapp"
              @click="openUrl"
            />-->
          </el-form-item>
          <el-form-item
            prop="password"
            class="cust-form-item"
            :rules="{ validator: handlePasswordLevel, trigger: 'change' }"
          >
            <el-popover
              ref="popover"
              :placement="isMobile?'top-start':'right'"
              width="200"
              trigger="focus"
            >
              <div :style="'color:' + levelColor[levelStatus]">
                <i :class="levelClass[levelStatus]"></i>
                {{ levelNames[levelStatus] }}
              </div>
              <div style="display: flex; margin-top: 10px">
                <el-progress
                  style="width: 33%"
                  v-for="(item, id) in levelNames"
                  :key="id"
                  v-if="id > 0"
                  :percentage="
                    id > levelStatus ? 0 : id < levelStatus ? 100 : levelPercent
                  "
                  :show-text="false"
                  :color="levelColor[levelStatus]"
                ></el-progress>
              </div>
            </el-popover>
            <el-input
              v-popover:popover
              :type="passw"
              @focus="changeType"
              v-model="registerForm.password"
              class="cust-input"
              autocomplete="new-password"
              placeholder="Password"
            >
              <i slot="suffix" @click="showPass">
                <img
                  v-if="passw=='password'"
                  class="reg-show-hide-icon"
                  src="../../assets/img/icon-hide.png"
                  alt="" />
                <img
                  v-else
                  class="reg-show-hide-icon"
                  src="../../assets/img/icon-show.png"
                  alt="" />
              </i>
            </el-input>
          </el-form-item>
          <p class="form-info click-sign">
            <span>By clicking Sign up, you agree to our</span>
            <span @click="gourl('/term-service')"
              >Terms of Service</span
            >
          </p>
          <el-form-item class="reg-next"
            ><el-button
              type="primary"
              :disabled="reging"
              @click="submitForm('registerForm')"
              class="btn"
              >Next</el-button
            ></el-form-item
          >
          <p class="form-info have-acct">
            <span>Already have ShopVidi account？</span>
            <span @click="loginType = 'login'">Log in now</span>
          </p>
          <GoogleLogin @googleCallBack="googleCallBack"/>
        </el-form>
      </div>
      <div v-if="step == 1" class="register-step1">
        <img src="https://master-shopvidi.s3.amazonaws.com/index_images/shop_logo%402x.png" class="show" />
        <h3>About your shop</h3>
        <p>
          Complete your profile so we can use AI Engine to help you pick the
          best winning products
        </p>
        <el-form :model="infoForm" >
          <el-form-item :label="labelObject.shopLabel">
            <el-select
              v-model="infoForm.onlineShopType"
              clearable
              placeholder="Select an option"
              @change="changeOnlineShopTyoe"
            >
              <el-option
                v-for="(item, id) in onlineShop"
                :key="item"
                :label="item"
                :value="id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="labelObject.shopPlatformLabel" v-if="showOnline">
            <el-select
              v-model="infoForm.shopPlatform"
              clearable
              placeholder="Select an option"
            >
              <el-option
                v-for="(item, id) in platform"
                :key="item"
                :label="item"
                :value="id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="labelObject.shopUrlLabel" v-if="showOnline">
            <el-input placeholder="" v-model="infoForm.shopUrl">
              <template slot="prepend"> Http:// </template>
            </el-input>
          </el-form-item>
          <el-form-item :label="labelObject.storeAddressLabel" v-if="showOffline">
            <el-input placeholder="Enter Store Address" v-model="infoForm.storeAddress" maxlength="200"></el-input>
          </el-form-item>
          <el-row v-if="showOffline">
            <el-col :span="12">
              <el-form-item :label="labelObject.stateLabel" >
                <el-input placeholder="Enter Store State" v-model="infoForm.state" maxlength="200"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="labelObject.cityLabel">
                <el-input placeholder="Enter Store City" v-model="infoForm.city" maxlength="200"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="showOffline">
            <el-col :span="12">
              <el-form-item :label="labelObject.countryLabel">
                <el-input placeholder="Enter Store Country*" v-model="infoForm.country" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" >
              <el-form-item :label="labelObject.zipCodeLabel">
                <el-input placeholder="Enter Store Zipcode*" v-model="infoForm.zipCode" maxlength="5" @input="changeZipCode" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item>
            <el-button @click="submitInfo" type="primary" class="btn"
              >Next</el-button
            >
            <div
              v-if="showSkip"
              @click="hidePop"
              style="{
                text-align: center;
                cursor: pointer;
                color: #999;
                margin-top: 20px;
              }
              "
            >
              Skip
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div v-if="step == 2" class="register-step1">
        <img src="https://master-shopvidi.s3.amazonaws.com/index_images/shop_logo%402x.png" class="show" />
        <h3>About your shop</h3>
        <el-form :model="infoForm" >
          <el-form-item label="What kind of store do you have?">
            <el-select
              v-model="infoForm.storeType"
              clearable
              placeholder="Select an option"
            >
              <el-option
                v-for="(item, id) in kind"
                :key="item"
                :label="item"
                :value="id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="What’s your annual turnover?">
            <el-select
              v-model="infoForm.annualTurnover"
              clearable
              placeholder="Select an option"
            >
              <el-option
                v-for="(item, id) in turnover"
                :key="item"
                :label="item"
                :value="id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="When did you open your store?">
            <el-select
              v-model="infoForm.openYears"
              clearable
              placeholder="Select an option"
            >
              <el-option
                v-for="(item, id) in openYear"
                :key="item"
                :label="item"
                :value="id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Business Type?">
            <el-select
              v-model="infoForm.businessType"
              clearable
              placeholder="Select an option"
            >
              <el-option
                v-for="(item, id) in businessTypeList"
                :key="item"
                :label="item"
                :value="id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="How did you hear About Us?">
            <el-select
              v-model="infoForm.source"
              clearable
              placeholder="Select an option"
            >
              <el-option
                v-for="(item, id) in sources"
                :key="item"
                :label="item"
                :value="id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Which categories are you interested in?">
            <el-checkbox-group
              v-model="infoForm.interestedCategory"
              @change="selectBox"
              style="display: block; width: 100%"
            >
              <el-checkbox
                v-for="(item, id) in groupList"
                :key="item.id + '-' + item.cateName"
                :label="item.id + '-' + item.cateName"
                name="type"
              >{{item.cateName}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item>
            <el-button
              @click="submitForm('infoForm')"
              type="primary"
              class="btn"
              >Submit</el-button
            >
            <div
              @click="step = 1"
              style="
                text-align: center;
                cursor: pointer;
                color: #8f8f8f;
                margin-top: 20px;
              "
            >
              Back
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { postAction, getAction } from '@/api/manage.js'
import {forceInitWebSocket} from '../../utils/ws'
import code from './code.js'
import Vue from 'vue'
import { phoneRules } from '../../components/validateRules'
import GoogleLogin from './google-login.vue'
//
export default {
  components: {
    GoogleLogin
  },
  name: 'Login',
  props: {
    submitHandle: {
      type: Function
    },
    type: {
      type: String
    }
  },

  data() {
    return {
      loginLoading: false,
      levelNames: ['low', 'low', 'Medium', 'Strong'],
      levelClass: [
        'el-icon-error',
        'el-icon-error',
        'el-icon-warning',
        'el-icon-success'
      ],
      levelColor: ['#ff0000', '#ff0000', '#ff7e05', '#52c41a'],
      levelStatus: 0,
      levelPercent: 10,
      timeValue: 'Send',
      loginType: this.type,
      step: 0,
      onlyPhoneFlag: false,
      groupList: [
        // 'Home Decor',
        // 'Jewelry',
        // 'Kids & Baby',
        // 'Beauty & Wellness',
        // 'Women',
        // 'Sports & Outdoors',
        // 'Men',
        // 'Pets',
        // 'Computer & Office'
      ],
      codeObject: '',
      newCountryCode: '',
      options: JSON.parse(localStorage.getItem('allCountry')) || [],
      countryNameCode: '',
      platform: code.platform,
      onlineShop: code.onlineShopType,
      businessTypeList: code.businessTypeList,
      turnover: code.turnover,
      kind: code.kind,
      openYear: code.openYear,
      sources: code.sources,
      usCode: [],
      registerForm: {
        email: '',
        password: '',
        code: '',
        phone: '',
        countryCode: '+1(US)',
        firstName: '',
        lastName: ''
      },
      loginForm: {
        email: '',
        password: '',
        remember: true
      },
      infoForm: {
        email: '',
        firstName: '',
        lastName: '',
        phone: '',
        shopPlatform: '',
        storeType: '',
        onlineShopType: '',
        shopUrl: '',
        annualTurnover: '',
        openYears: '',
        interestedCategory: [],
        source: '',
        businessType: '',
        // TODO 新增字段
        state: '',
        city: '',
        country: 'United States of America',
        storeAddress: '',
        zipCode: ''
      },
      labelObject: {
        shopLabel: 'Do you have an online shop?',
        shopPlatformLabel: 'Shop Platform',
        shopUrlLabel: 'Shop URL',
        storeAddressLabel: 'Store Address',
        stateLabel: 'State',
        cityLabel: 'City',
        countryLabel: 'Country',
        zipCodeLabel: 'Zipcode'
      },
      showSkip: true,
      showOnline: false,
      showOffline: false,
      emailLimit: '',
      onlyFlag: false,
      passw: 'password',
      reging: false,
      googleLogin: false,
      rules: {
        phone: [{}]
      }
    }
  },
  watch: {
    registerForm: {
      handler(n, o) {},
      deep: true
    },
    'registerForm.countryCode'(newVal) {
      console.log(this.registerForm.countryCode)
      this.rules.phone = [
        { required: true, message: 'Please enter the correct number', trigger: 'blur'},
        { validator: phoneRules(this.registerForm.countryCode), trigger: ['change', 'blur']},
        { validator: this.checkOnlyPhone, trigger: 'change'}
      ]
    }
  },
  mounted() {
    // this.rules.phone = [
    //     { validator: phoneRules(this.registerForm.countryCode), trigger: ['change','blur']},
    //     { validator: this.checkOnlyPhone, trigger: ['change','blur']}
    //   ]
  },
  computed: {
    isMobile() {
      return navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    }
  },
  created() {
    this.getPhoneAndCountry()
    this.registerForm.countryCode = '+1(US)'
    this.rules.phone = [
      { required: true, message: 'Please enter the correct number', trigger: 'blur'},
      { validator: phoneRules(this.registerForm.countryCode), trigger: 'change'},
      { validator: this.checkOnlyPhone, trigger: 'change'}
    ]
    this.codeObject = '+1(US)'
    this.setUsCode()
    // haoyuanw add 2021-11-22 增加查询分类信息
    this.loadCategory()
    // haoyuanw add 2021-12-22 查询配置信息
    this.loadConfiguration()
    this.loadConfigurationEmal()
    console.log('000')
    const password = this.$cookie.get('password')
    const email = this.$cookie.get('email')
    if (password && email) {
      this.loginForm.email = email
      this.loginForm.password = password
    }
  },
  methods: {
    googleCallBack(googleOauth2Code) {
      if (this.loginType === 'login') {
        this.googleLogin = true
      }
      if (this.loginType === 'register') {
        this.reging = true
      }
      if (!googleOauth2Code || googleOauth2Code === 'undefined') {
        this.googleLogin = false
        this.reging = false
        return
      }
      // TODO 加一个接口获取token
      postAction('/google/oauth-token', {code: googleOauth2Code, redirectUri: window.location.origin}).then(responseToken => {
        if (responseToken.success) {
          if (responseToken.result) {
            // 间隔2秒看效果调用后端接口再取消加载中
            postAction('/google/login', {token: responseToken.result}).then(response => {
              if (response.success) {
                this.googleLogin = false
                this.reging = false
                if (response.result) {
                  if (response.result.login_state === 'SIGN_UP_REQUIRED') {
                    const signUpSuggestions = response.result.sign_up_suggestions
                    this.$router.push({path: '/google-register', query: {email: signUpSuggestions.email_address, first_name: signUpSuggestions.first_name, last_name: signUpSuggestions.last_name, profile_image_url: signUpSuggestions.profile_image_url}})
                  }
                  if (response.result.login_state === 'LOGIN_IN_REQUIRED') {
                  // 登录信息补充到localStorage中
                    this.$ls.set('token', response.result.user_info.token)
                    this.$ls.set('userInfo', response.result.user_info.userInfo)
                    this.$ls.set('realname', response.result.user_info.userInfo.realname)
                    forceInitWebSocket()
                    Vue.prototype.login = true
                    // haoyuanw add 2023-08-15 增加klaviyo传数据
                    klaviyo.push(['identify', {
                      '$email': response.result.user_info.userInfo.email,
                      '$first_name': response.result.user_info.userInfo.firstName,
                      '$last_name': response.result.user_info.userInfo.lastName,
                      '$phone_number': response.result.user_info.userInfo.phone
                    }])
                    location.reload()
                  }
                  if (response.result.login_state === 'TOKEN_INVALID') {
                    this.$message.warning('TOKEN_INVALID')
                  }
                }
              } else {
                this.$message.warning(response.message)
                this.googleLogin = false
                this.reging = false
              }
            })
          }
        } else {
          this.$message.warning(responseToken.message)
          this.googleLogin = false
          this.reging = false
        }
      })
    },
    checkOnlyPhone(rule, value, callback) {
      this.checkOnlyEmailOrPhone(value, 'phone')
      let that = this
      setTimeout(function () {
        if (that.loginType == 'login') {
          callback(that.onlyPhoneFlag ? '' : (new Error('There’s no account associated with that phone. Try Again')))
        } else {
          callback(that.onlyPhoneFlag ? (new Error('Phone registered')) : '')
        }
      }, 500)
    },
    async checkOnlyEmailOrPhone(value, type) {
      let path = '/sys/user/checkOnlyUser'
      if (type == 'email') {
        let res = await getAction(path, {
          email: value
        })
        // true ：表示存在
        this.onlyEmailFlag = !res.success
      } else {
        let phoneWithCode = this.registerForm.countryCode + '-' + value
        let res = await getAction(path, {
          phone: phoneWithCode
        })
        this.onlyPhoneFlag = !res.success
      }
    },
    changePhone(value) {
      this.registerForm.phone = value.replace(/[^\d]/g, '')
    },
    codeChange(code) {
      this.registerForm.countryCode = code.value
      this.codeObject = code.value
      if (code.desc) {
        let numberValue = code.desc.split(':')
        console.log(numberValue)
        this.newCountryCode = numberValue[0]
      }
    },
    showPass() {
      // 点击图标是密码隐藏或显示
      if (this.passw == 'text') {
        this.passw = 'password'
      } else {
        this.passw = 'text'
      }
    },
    changeZipCode(value) {
      this.infoForm.zipCode = value.replace(/[^\d]/g, '')
    },
    // 获取国家、手机号配置信息
    getPhoneAndCountry() {
      getAction('/sys/dict/getDictItems/reg-country-config').then(response => {
        if (response.success) {
          if (response.result) {
            this.options = response.result
            localStorage.setItem('allCountry', JSON.stringify(response.result))
            console.log(JSON.parse(localStorage.getItem('allCountry')), '存到localStorage里的country')
          }
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    /**
     * 检查邮箱
     */
    checkEmail(rule, value, callback) {
      if (value) {
        value = value.trim()
      }
      var reg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      //  先判断格式是否正确，格式不正确则直接返回
      if (reg.test(value)) {
        //  判断我们是否有邮箱验证，
        if (this.emailLimit !== '') {
          let index = value.indexOf('@')
          if (index > -1) {
            const emailSuffix = value.substring(index, value.length)
            if (this.emailLimit.indexOf(emailSuffix) > -1) {
              callback(new Error('Please enter your email, if you cannot register, please contact customer service'))
              return
            }
            callback()
          }
          callback(new Error('Please enter the correct email address'))
          return
        }
        // this.checkOnlyEmail(value)
        getAction('/sys/user/checkOnlyUser', {email: value}).then(response => {
          this.onlyFlag = !response.success
          if (this.loginType === 'login') {
            callback(this.onlyFlag ? '' : (new Error('There’s no account associated with that email. Try Again')))
          } else {
            callback(this.onlyFlag ? (new Error('Email registered')) : '')
          }
        })
      } else {
        callback(new Error('Please enter the correct email address'))
      }
    },
    async checkOnlyEmail(email) {
      let res = await getAction('/sys/user/checkOnlyUser', {
        email: email
      })
      // true ：表示存在
      this.onlyFlag = !res.success
    },
    changeOnlineShopTyoe(value) {
      if (value === '') {
        this.showOnline = false
        this.showOffline = false
        return
      }
      if (value === 0 || value === 3) {
        // TODO 线下店
        this.showOffline = true
        this.showOnline = false
        return
      }
      if (value === 2 || value === 4) {
        // TODO 线上店
        this.showOnline = true
        this.showOffline = false
        return
      }
      if (value === 1) {
        // TODO 线上线下店
        this.showOnline = true
        this.showOffline = true
      }
    },
    submitInfo() {
      // 首先判断是否需要必填，如果不必填跳转下一页即可
      if (this.showSkip) {
        this.step = 2
        return
      }
      if (this.infoForm.onlineShopType === '') {
        this.$message.warning('Please enter an online shop')
        return
      }
      // TODO 如果是线上店
      if (this.showOnline) {
        if (this.infoForm.shopPlatform === '') {
          this.$message.warning('Please enter an shop platform')
          return
        }
        if (this.infoForm.shopUrl === '') {
          this.$message.warning('Please enter an shop url')
          return
        }
      }
      if (this.showOffline) {
        if (this.infoForm.storeAddress === '') {
          this.$message.warning('Please enter an store address')
          return
        }
        if (this.infoForm.state === '') {
          this.$message.warning('Please enter an store state')
          return
        }
        if (this.infoForm.city === '') {
          this.$message.warning('Please enter and store city')
          return
        }
        if (this.infoForm.zipCode === '') {
          this.$message.warning('Please enter and store zipcode')
          return
        }
      }
      // TODO 如果都填写了 则直接提交
      this.infoFormHandle(false)
    },
    loadConfigurationEmal() {
      getAction('/simple/configuration?key=sign_up_email_limit').then(response => {
        if (response.success) {
          if (response.result.configurationValue) {
            if (response.result.configurationValue !== '') {
              this.emailLimit = response.result.configurationValue
            }
          }
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    loadConfiguration() {
      getAction('/simple/configuration?key=sign_up_show_skip').then(response => {
        if (response.success) {
          if (response.result.configurationValue) {
            if (response.result.configurationValue === 'disable') {
              const param = {
                shopLabel: 'Do you have an online shop?*',
                shopPlatformLabel: 'Shop Platform*',
                shopUrlLabel: 'Shop URL*',
                storeAddressLabel: 'Store Address*',
                stateLabel: 'State*',
                cityLabel: 'City*',
                countryLabel: 'Country*',
                zipCodeLabel: 'Zipcode*'
              }
              this.labelObject = param
              this.showSkip = false
            }
          } else {
            this.$message.warning('Query Configuration Error!')
          }
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    loadCategory() {
      getAction('/tsCategory/tsCateInfo/list1').then(response => {
        if (response.success) {
          this.groupList = response.result
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    signUp() {
      this.loginType = 'register'
      // eslint-disable-next-line no-undef
      gtag('event', 'click', {
        'event_category': 'sign_up'
      })
      // TODO haoyuanw add 20211103 添加 首页
      // eslint-disable-next-line no-undef
      mixpanel.track('v_signup_popup', {'page_from': window.location.href})
    },
    changeType(e) {
      e.srcElement.type = 'password'
    },
    getEnvUrl() {
      let href = window.location.href
      let url = window.location.host
      if (href.indexOf('test') >= 0) {
        url = 'https://test-thalesmart-manage-ui.hupofintech.com'
        return url
      }
      if (href.indexOf('localhost') >= 0) {
        url = 'http://localhost:8080'
        return url
      }
      if (href.indexOf('shopvidi') >= 0) {
        url = 'https://p.shopvidi.com'
        return url
      }
    },
    gourl(url) {
      /* let href = this.getEnvUrl()
      window.open(href + url) */
      this.$router.push('/term-service')
    },
    openUrl() {
      window.open(
        'https://api.whatsapp.com/send/?phone=85260904204&text&app_absent=0'
      )
    },
    userNameCheck(rule, value, callback) {
      if (this.registerForm.firstName == '') {
        callback(new Error('Please enter the firstName'))
      }

      callback()
    },
    userNameCheck2(rule, value, callback) {
      if (this.registerForm.lastName == '') {
        callback(new Error('Please enter the lastName'))
      }
      callback()
    },
    // 密码强度校验
    handlePasswordLevel(rule, value, callback) {
      let level = 0
      let reg =
        /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,./]).{8,}$/
      if (value == '') {
        callback(new Error('Please enter the Password'))
      }
      if (!reg.test(value)) {
        callback(
          new Error(
            'The password contains at least 8 characters, a combination of letters, numbers and special characters'
          )
        )
      }
      // 判断这个字符串中有没有数字
      if (/[0-9]/.test(value)) {
        level++
      }
      // 判断字符串中有没有字母
      if (/[a-zA-Z]/.test(value)) {
        level++
      }
      // 判断字符串中有没有特殊符号
      if (/[^0-9a-zA-Z_]/.test(value)) {
        level++
      }
      this.levelStatus = level
      this.levelPercent = level * 30
      if (level >= 2) {
        if (level >= 3) {
          this.levelPercent = 100
        }
        callback()
      } else {
        if (level === 0) {
          this.levelPercent = 10
        }
        callback(new Error('The password strength is not enough'))
      }
    },
    // 登陆接口
    async loginHandle(status) {
      if (this.loginLoading) {
        return
      }
      this.loginLoading = true
      mixpanel.track('c_login_button')
      let username = this.loginForm.email.trim()
      let res = await postAction('/sys/login', {
        password: this.loginForm.password,
        remember_me: this.loginForm.remember,
        username: username,
        loginEntry: 1
      })
      if (res.code == 200) {
        if (this.loginForm.remember) {
          this.$cookie.set('password', this.loginForm.password, 365)
          this.$cookie.set('email', username, 365)
        }
        this.$ls.set('token', res.result.token)
        this.$ls.set('userInfo', res.result.userInfo)
        this.$ls.set('realname', res.result.userInfo.realname)
        Vue.prototype.login = true
        this.loginLoading = false
        // add by cpgu 2023/03/07 begin
        try {
          forceInitWebSocket()
        } catch (e) {
          // 此处不能影响主业务
          console.error(e)
        }
        // end by cpgu

        // haoyuanw add 2021-10-19 增加识别访客功能
        var _hsq = window._hsq = window._hsq || []
        _hsq.push(['identify', {
          email: res.result.userInfo.email,
          id: res.result.userInfo.id
        }])
        gtag('event', 'click', {
          'event_category': 'successlogin'
        })
        // haoyuanw add 2023-08-15 增加klaviyo传数据
        klaviyo.push(['identify', {
          '$email': res.result.userInfo.email,
          '$first_name': res.result.userInfo.firstName,
          '$last_name': res.result.userInfo.lastName,
          '$phone_number': res.result.userInfo.phone
        }])
        this.changeURLStatic('signin', '')
        this.changeURLStatic('signup', '')

        if (!status) {
          this.$emit('submitHandle')
        }
        // eslint-disable-next-line no-undef
        // mixpanel.register({emai: this.loginForm.email})
        // TODO haoyuanw add 2021-11-18 添加用户维度信息
        // eslint-disable-next-line no-undef
        mixpanel.identify(res.result.userInfo.id)
        // eslint-disable-next-line no-undef
        mixpanel.people.set({'email': this.loginForm.email})
        mixpanel.track('api_login_success')
      } else {
        this.loginLoading = false
        this.$message.warning(res.message)
        mixpanel.track('api_login_fail', {'login_fail_season': res.message})
      }
    },
    changeURLStatic(name, value) {
      var url = location.href
      var reg = eval('/([?|&]' + name + '=)[^&]*/gi')
      value = value.toString().replace(/(^\s*)|(\s*$)/g, '') // 移除首尾空格
      if (!value) {
        var url2 = url.replace(reg, '') // 正则替换
      } else {
        if (url.match(reg)) {
          var url2 = url.replace(reg, '$1' + value) // 正则替换
        } else {
          var url2 =
            url + (url.indexOf('?') > -1 ? '&' : '?') + name + '=' + value // 没有参数添加参数
        }
      }
      history.replaceState(null, null, url2) // 替换地址栏
    },
    hidePop() {
      this.$emit('submitHandle')
    },
    // 注册接口
    registerHandle() {
      mixpanel.track('c_sign_up_button')
      let values = this.registerForm
      if (values.countryCode == '') {
        this.$message.warning('Please enter country code!')
        return
      }
      if (this.reging) {
        return
      }
      this.reging = true

      var register = {
        phone: values.countryCode + '-' + values.phone,
        firstName: values.firstName,
        lastName: values.lastName,
        password: values.password,
        email: values.email,
        verifyCode: values.code,
        userSource: 1,
        countryCode: this.registerForm.countryCode == '+1(US)' ? 'US' : this.newCountryCode
      }
      register.utmSource = localStorage.getItem('utm_source')
      register.utmMedium = localStorage.getItem('utm_medium')
      register.utmCampaign = localStorage.getItem('utm_campaign')
      register.utmId = localStorage.getItem('utm_id')
      register.utmTerm = decodeURIComponent(localStorage.getItem('utm_term'))
      register.utmContent = localStorage.getItem('utm_content')
      register.hostId = localStorage.getItem('mac')
      postAction('/sys/user/register', register).then((res) => {
        if (res.success) {
          this.loginForm = {
            ...register,
            ...{
              remember_me: true
            }
          }
          this.loginHandle(true).then(res => {
            //add by cpgu 2024/05/13 注册成功，赋值用户信息至全局变量，解决vilocal下单页无法加载问题 begin
            let userInfo = JSON.parse(localStorage.getItem('pro__userInfo'))
            Vue.prototype.userInfoObject = userInfo.value
            //end by cpgu

            this.$router.push('/profile')
            this.reging = false
          })
          // eslint-disable-next-line no-undef
          gtag('event', 'click', {
            'event_category': 'successsignup'
          })
          // eslint-disable-next-line no-undef
          gtag('event', 'conversion', {'send_to': 'AW-10872160881/iKr4CKfT66sDEPGEoMAo'})
          gtag('event', 'conversion', {'send_to': 'AW-301131205/cYGMCNH0ybIDEMXLy48B'})
          gtag('event', 'conversion', {'send_to': 'AW-342118137/59c2CI3FsuMCEPmdkaMB'})
          gtag('event', 'conversion', {'send_to': 'AW-10888618638/gDZdCJbUmLYDEI7FjMgo'})
          // haoyuanw add 2021-10-21 完成注册调用FB
          // eslint-disable-next-line no-undef
          fbq('track', 'CompleteRegistration')
          // eslint-disable-next-line no-undef
          mixpanel.people.set({$email: register.email, $name: register.firstName + '-' + register.lastName})
          // TODO haoyuanw add 20211103 添加 注册客户信息页
          // eslint-disable-next-line no-undef
          mixpanel.track('api_register_success')
          heap.addEventProperties({ 'api_register_success': 'true', 'api_register_success_user': this.loginForm.email })
          //    heap.clearEventProperties()
        } else {
          this.$message.warning(res.message)
          // TODO haoyuanw add 20211103 添加 注册失败
          // eslint-disable-next-line no-undef
          mixpanel.track('api_register_fail', {'register_fail_season': res.message})
          heap.addEventProperties({ 'api_register_fail': 'true', 'api_register_fail_reason': register.email + '----------->' + res.message })
          // heap.clearEventProperties()
        }
      })
    },
    // 编辑用户信息
    async infoFormHandle(flag) {
      let data = {
        ...this.infoForm,
        ...{
          email: this.registerForm.email,
          firstName: this.registerForm.username,
          lastName: this.registerForm.username2,
          phone: this.loginForm.phone
        }
      }
      postAction('/shop-user/save-info', data).then((res) => {
        if (res.success) {
          if (flag) {
            this.$emit('submitHandle')
            return
          }
          this.step = 2
        }
      })
    },
    // 发送邮箱验证码
    async getCode() {
      if (this.registerForm.email == '') {
        return
      }
      const that = this
      let timeValue = this.timeValue
      let time = 60
      let interval = window.setInterval(() => {
        time--
        if (time <= 0) {
          time = 60
          that.timeValue = timeValue
          window.clearInterval(interval)
        } else {
          that.timeValue = time
        }
      }, 1000)
      const params = {
        email: that.registerForm.email,
        msgType: '1'
      }

      getAction('/sys/user/sendEmailMsg', params)
        .then((res) => {
          if (res.success) {
          }
        })
        .catch((err) => {
          clearInterval(interval)
          time = 60
          that.timeValue = timeValue
        })
    },
    // 获取手机号code
    async getPhoneCode() {},
    // 校验手机号
    setUsCode() {
      let arr = []
      let brr = [
        ['242', '250', '281'],
        ['320', '330', '334', '352', '360'],
        ['423', '441', '450', '456'],
        ['520', '540', '541', '561', '562', '573'],
        ['626', '630'],
        ['760', '770', '773'],
        ['847', '860', '864'],
        ['941', '954', '970', '972']
      ]

      for (let i = 2; i < 10; i++) {
        for (let j = 0; j < 10; j++) {
          arr.push(i + '0' + j)
          arr.push(i + '1' + j)
        }

        arr = [...arr, ...brr[i - 2]]
      }
      this.usCode = arr
    },
    checkPhone(rule, value, callback) {
      let phone = this.addressForm.phone
      let code = this.addressForm.areaCode
      if (code === '') {
        callback(new Error('Please enter the country code'))
      }
      if (phone === '') {
        callback(new Error('Please enter the phone!'))
      }
      // 如果是美国或者英国则判断后面手机号的长度
      if (code.indexOf('+1(US)') > -1 || code.indexOf('+1(CA)') > -1) {
        if (phone.length !== 10) {
          callback(new Error('Please enter the correct number'))
        }
      }
      if (code.indexOf('+44(UK)') > -1) {
        if (phone.length !== 10 && phone.length !== 11) {
          callback(new Error('Please enter the correct number'))
        }
      }
      if (code.indexOf('+61(AU)') > -1) {
        if (phone.length !== 9) {
          callback(new Error('Please enter the correct number'))
        }
      }
      if (code.indexOf('+64(NZ)') > -1) {
        if (phone.length !== 8 && phone.length !== 9 && phone.length !== 10) {
          callback(new Error('Please enter the correct number'))
        }
      }
      callback()
    },
    async submitForm(type) {
      if (type == 'loginForm') {
        this.$refs[type].validate(async (valid) => {
          if (valid) {
            this.loginHandle()
          }
        })
      } else if (type == 'registerForm') {
        this.$refs[type].validate(async (valid) => {
          if (valid) {
            this.vaildPointHeap(true)
            this.registerHandle()
          } else {
            this.vaildPointHeap(false)
          }
        })
      } else if (type == 'infoForm') {
        if (this.step === 1) {
          this.infoFormHandle(false)
          return
        }
        this.infoFormHandle(true)
      }
    },
    vaildPointHeap(flag) {
      // notes 增加埋点表单
      let tempRegisterForm = {}
      for (let n in this.registerForm) {
        tempRegisterForm[n] = this.registerForm[n]
      }
      tempRegisterForm.password = '***'
      heap.addEventProperties({ 'Form validation': flag, 'Form Data': JSON.stringify(tempRegisterForm) })
      // heap.clearEventProperties()
    }

  }

}
</script>

<style scoped="scoped" lang="less">
div,span{
  font-family: Satoshi;
}

.el-checkbox {
  width: 40%;
}
.wapp {
  position: absolute;
  right: 5px;
  width: 22px;
}
.login-btn{
  margin-top: 60px;
}

.register-step1 {
  > h3 {
    font-size: 20px;
    font-weight: 800;
    line-height: 36px;
    margin-bottom: 0px;
    color: #262b2f;
    text-align: center;
  }
  > p {
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
    text-align: left;
    color: #262b2f;
    margin-bottom: 10px;
  }
}
.container {
  position: relative;
  width: 100%;
  min-height: 560px;
  box-sizing: border-box;
  padding: 40px 40px 20px 470px;
  background: url(https://master-shopvidi.s3.amazonaws.com/about/login_bg.jpg) no-repeat 0 0;
  background-size: 430px 100%;
  .el-form-item {
    position: relative;
    display: block;
    text-align: left;
    .forget-btn {
      position: absolute;
      right: 0;
      top: 0;
      font-weight: 0;
      color: #262613;
      cursor: pointer;
      text-decoration: underline;

    }
  }

  .logo {
    display: block;
    width: 174px;
    margin: 0 auto 40px;
  }
  .login-logo{
    margin-bottom: 50px;
  }
  .reg-logo{
    margin-bottom:15px;
  }
  .btn {
    display: block;
    width: 100%;
    height: 50px;
    color: #262613;
    background: #F3E93D;
    border-color: #F3E93D;
  }
  .btn1 {
    display: block;
    width: 100%;
    height: 50px;
    border: 1px solid #E1E1E1;

  }
  .btn2 {
    width: 150px;
    height: 40px;
    border-radius: 0;
    color: #FF4812;
    &:hover {
      background-color: #fff;
      border-color: #dcdfe6;
    }
  }
  .info {
    position: absolute;
    left: 20px;
    top: 20px;
    width: 400px;
    text-align: left;
    font-size: 20px;
    font-weight: 500;
    line-height: 36px;
    color: #262b2f;
    word-break: keep-all;
    font-family: Satoshi-Medium;

  }
  .info-sub{
    position: absolute;
    left: 20px;
    top: 120px;
    font-size: 14px;
    font-weight: 500;
    color: #5D5D5D;

  }

  .form-info {
    padding: 0 0 10px;
    text-align: center;
    line-height: 30px;
    word-break: keep-all;
    font-size: 11px;
    span{
      &:nth-child(1){
        color: #8F8F8F;
      }
      &:nth-child(2) {
        color: #262613;
        cursor: pointer;
        word-wrap: break-word;
        text-decoration: underline;
      }
    }

  }
  .reg-next{
    margin-bottom: 0px !important;
  }
}
.register-step1 {
  .el-form-item {
    margin-bottom: 12px;
  }
  .el-form-item__content {
    line-height: 20px;
  }
}
.show {
  display: none;
}
.demo-ruleForm{
  .el-form-item {
    margin-bottom: 35px;
  }
}

.register{
  min-width: 200px;
}

.have-acct{
  line-height: 20px !important;
  margin-top: 20px;
}
.reg-show-hide-icon{
  width:16px;height:16px;position: relative;top: 10px;
}
.cust-form-item2{
  border-bottom: 1px solid #262B2F !important;
}

@media screen and (min-width: 600px) {
  .el-select-dropdown__item{
    width: 370px;
  }
  /deep/ .el-select-dropdown__item{
    width: 370px;
  }
}
@media screen and (max-width: 600px) {
  .show {
    display: block;
    width: 145px;
    margin: 40px auto 40px;
  }
  .container {
    box-sizing: border-box;
    padding: 58px 0 0;
    background: none;
    background-size: 100%;
    .info {
      top: 30px;
      font-size: 18px;
      max-width: 100%;
      width: 320px;
    }
    .form-info {
      font-size: 12px;
    }
    .register,
    .login {
      width: 100%;
      background: #fff;
      box-sizing: border-box;
      padding: 20px;

    }
  }
  .step1,
  .step2 {
    padding: 0;
    .info {
      display: none;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/components/login.vue